import React from "react";
import "../style/Bookdemo.css"
import { Nav } from "../layouts/headernew";
import { ToothZapFooter2 } from "../layouts/footernew";


export default function Bookdemo() {
  return (
    <div >
            <Nav />
        <div className="book-wrapper mt-5 pt-5">
      <div className="book-container">

        {/* LEFT */}
        <div className="left-sectionbookdemo">
          <div>
            <p className="small-title">DEMO OVERVIEW</p>

            <h1 className="see-toothzap">
              See ToothZap in <br /> 20 minutes.
            </h1>

            <ul>
              <li>90-min crown</li>
              <li>Warranted on every case</li>
              <li>Used by X Delhi clinics</li>
            </ul>
          </div>

          <div className="testimonial">
            <p>
            ToothZap made the workflow visible enough that our team could quote the patient and complete the fitment in the same session.
            </p>
            <span>Dr. Rhea Nanda · Prosthodontist · Greater Kailash</span>
          </div>
        </div>

        {/* RIGHT */}
        <div className="right-section-book-demo">
          <p className="blue-title">BOOK DEMO</p>

          <h2 className="see-the-workflow">
            See the workflow, the  <br/> 
            turnaround, and the operating <br/>model in one walkthrough.
          </h2>

          <form>
            <label className=" full-name-text">Full name</label>
            <input className="custom-book-demo-input" placeholder="Your full name" />

            <label className=" full-name-text">Clinic or lab name</label>
            <input className="custom-book-demo-input" placeholder="Clinic or lab name" />

            <label className=" full-name-text">Email</label>
            <input className="custom-book-demo-input" placeholder="you@clinic.com" />

            <label className=" full-name-text">Phone</label>
            <input className="custom-book-demo-input" placeholder="+91" />

            <label className=" full-name-text">Role</label>
            <select className="custom-book-demo-input">
              <option>Other</option>
            </select>

            <label className="full-name-text">City</label>
            <input className="custom-book-demo-input" placeholder="City" />

            <button className="book-my-demobtn">Book my demo</button>

            <p className="note">
              We'll confirm within 2 hours. No hard sell.<br />
              By submitting, you agree to our <span>Privacy Policy</span>.
            </p>
          </form>

          <div className="calendar">
            <p className="cal-title">Calendly embed placeholder</p>
            <p className="cal-sub">
              This area will host the booking widget after Calendly is connected.
            </p>
            <div className="cal-box"></div>
          </div>
        </div>

      </div>
      </div>
       <ToothZapFooter2 />

    </div>
    
  );
}
